"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoBanner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
const PromoBanner = (param)=>{
    let { backgroundImage, backgroundVideo, promoBannerType, backgroundStorybookColor, link, title, caption, size, className } = param;
    const { relativeUrl } = link !== null && link !== void 0 ? link : {};
    const theme = (0, _mui.useTheme)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { isFocusPage } = (0, _contexts.useBannerProductListingContext)();
    const content = (0, _react.useMemo)(()=>{
        if (promoBannerType === _types.PromoBannerType.Video) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.PromoBannerVideo, {
                size: size,
                promoBannerType: promoBannerType,
                backgroundVideo: backgroundVideo
            });
        } else if (promoBannerType === _types.PromoBannerType.Image) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.PromoBannerImage, {
                size: size,
                promoBannerType: promoBannerType,
                backgroundImage: backgroundImage
            });
        } else if (promoBannerType === _types.PromoBannerType.Text) {
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.PromoBannerText, {
                title: title,
                size: size,
                link: link,
                promoBannerType: promoBannerType
            });
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.PromoBannerSplit, {
            size: size,
            promoBannerType: promoBannerType,
            backgroundImage: backgroundImage,
            backgroundVideo: backgroundVideo,
            title: title,
            caption: caption,
            link: link
        });
    }, [
        promoBannerType,
        size,
        backgroundImage,
        backgroundVideo,
        title,
        caption,
        link
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Banner, {
        className: className,
        size: size,
        "data-testid": getTestId(_constants.PROMO_BANNER),
        backgroundColor: (0, _presentationUtils.mapBackendColorToTheme)({
            backendColor: backgroundStorybookColor,
            fallBackColor: theme.palette.primary.main,
            theme
        }),
        href: relativeUrl !== null && relativeUrl !== void 0 ? relativeUrl : undefined,
        isFocusPage: isFocusPage,
        children: content
    });
};
exports.PromoBanner = PromoBanner;
